import { styled, Rating } from "@mui/material"

import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

export {BodyStat, SharpnesStat, MindStat, SoulStat }

const BodyStat = ({value, onChange,  disabled = false}: {value: number, onChange?: (stat: number) => void, disabled?: boolean}) => {
    const changeStat = (event: any, newValue: number | null) => {
         if (onChange != null)
            onChange(newValue!!) 
    }

    return (
    <StyledRatingRed
        name="customized-color"
        value={value}
        readOnly={disabled}
        onChange={changeStat}
        max={3}
        icon={<RadioButtonCheckedIcon fontSize="inherit" />}
        emptyIcon={<RadioButtonUncheckedIcon fontSize="inherit" />}
    />
)}

const SharpnesStat = ({value, onChange, disabled = false}: {value: number, onChange?: (stat: number) => void,  disabled?: boolean}) => {
    const changeStat = (event: any, newValue: number | null) => {
        if (onChange != null)
           onChange(newValue!!) 
   }

    return(
    <StyledRatingYelllow
        name="customized-color"
        value={value}
        readOnly={disabled}
        onChange={changeStat}
        max={3}
        icon={<RadioButtonCheckedIcon fontSize="inherit" />}
        emptyIcon={<RadioButtonUncheckedIcon fontSize="inherit" />}
    />
)}

const MindStat = ({value, onChange, disabled = false}: {value: number, onChange?: (stat: number) => void, disabled?: boolean}) => {
    const changeStat = (event: any, newValue: number | null) => {
        if (onChange != null)
           onChange(newValue!!) 
   }
    return(
    <StyledRatingGreen
        name="customized-color"
        value={value}
        readOnly={disabled}
        onChange={changeStat}
        max={3}
        icon={<RadioButtonCheckedIcon fontSize="inherit" />}
        emptyIcon={<RadioButtonUncheckedIcon fontSize="inherit" />}
    />
)
}

const SoulStat = ({value, onChange, disabled = false}: {value: number, onChange?: (stat: number) => void, disabled?: boolean}) => {
    const changeStat = (event: any, newValue: number | null) => {
        if (onChange != null)
           onChange(newValue!!) 
   }
 
    return(
    <StyledRatingBlue
        name="customized-color"
        value={value}
        max={3}
        readOnly={disabled}
        onChange={changeStat}
        icon={<RadioButtonCheckedIcon fontSize="inherit" />}
        emptyIcon={<RadioButtonUncheckedIcon fontSize="inherit"/>}
    />
)
}

const StyledRatingRed = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#ff6d75',
    },
    '& .MuiRating-iconHover': {
        color: '#ff3d47',
    },
});

const StyledRatingGreen = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#4caf50',
    },
    '& .MuiRating-iconHover': {
        color: '#388e3c',
    },
});

const StyledRatingBlue = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#2196f3',
    },
    '& .MuiRating-iconHover': {
        color: '#1976d2',
    },
});

const StyledRatingYelllow = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#ffeb3b',
    },
    '& .MuiRating-iconHover': {
        color: '#fbc02d',
    },
});